import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Acquisto} from "../_Models";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {DatePipe} from "@angular/common";
import {ApiRestService} from "../api-rest.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-conflitti',
  templateUrl: './conflitti.component.html'
})
export class ConflittiComponent implements OnInit {
  @Output() Uploaded = new EventEmitter<any>();
  @Input() acquisti: Acquisto[];
  @Input() stock: any[];
  @Input() produzione: any[];
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'voce'
  };
  constructor(
    private modalService : NgbActiveModal,
    private datepipe: DatePipe,
    private apiRestService: ApiRestService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
  }
  closeModal() {
    this.modalService.dismiss();
  }

  Save() {
    if(this.stock?.length > 0) {
      const send = this.SendData(this.stock);
      if(send)
        this.apiRestService.PrimanotaStockConflitti(send).subscribe(data=>this.Uploaded.emit(data));
     }
    else if(this.produzione?.length > 0){
      const send = this.SendData(this.produzione);
      if(send)
        this.apiRestService.PrimanotaProduzioneConflitti(send).subscribe(data=>this.Uploaded.emit(data));
    }
  }
  SendData(array: any[]){
    var canSend = true;
    const data = this.datepipe.transform(new Date(),'yyyy-MM-dd');
    var send : {conflitti:any[]} = {conflitti:[]};
    array?.forEach(element=>{
      if(!(element?.selezionato?.length > 0)) {
        this.toastrService.warning("Inserire tutte le corrispondenze");
        canSend = false;
      }
      send.conflitti.push({id: element?.selezionato[0]?.id, quantita: element?.quantita, data: data})
    });
    return canSend? send: undefined;
  }
}
